import { login } from '@/api/user'
import { accountLoginGet } from '@/api/Account'
import { getToken, setToken, removeToken } from '@/utils/auth'
import RSA from '@/utils/RSA'
// import router from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    userName: '',
    fullName: '',
    roles: [],
    userInfo: {}
  }
}

const state = getDefaultState()

const mutations = {
  SET_TOKEN: (state, token) => {
    token ? setToken(token) : removeToken()
    state.token = token
  },
  RESET_STATE: state => {
    Object.assign(state, getDefaultState())
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_USERNAME: (state, userName) => {
    state.userName = userName
  },
  SET_FULLNAME: (state, fullName) => {
    state.fullName = fullName
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_SYSID: (state, sysId) => {
    state.sysId = sysId
  },
  SET_ORGID: (state, orgId) => {
    state.orgId = orgId
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  }
}

const actions = {
  /**
   * @description: 用户登录
   * @author: linwen linwen@fjxhx.com
   * @createDate: 2020-10-22 9:32
   * @param: {commit} 提交 mutations
   * @param: {userInfo} 用户信息
   * @return:
   */
  login({ commit }, userInfo) {
    const { username, password, grant_type, scope, client_id, client_secret } = userInfo
    return new Promise((resolve, reject) => {
      login({
        username: username.trim(),
        password: RSA(password),
        grant_type,
        scope,
        client_id,
        client_secret: RSA(client_secret)
      }).then(response => {
        console.log('用户token信息', response)
        commit('SET_TOKEN', response.access_token)
        setToken(response.access_token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      accountLoginGet(state.token).then(response => {
        console.log('用户信息getInfo: ', response)
        if (!response) {
          return reject('验证失败, 请重新登录!')
        }
        // 存储用户信息
        const { roleList, name, avatar, introduction, userName, fullName } = response

        commit('SET_ROLES', roleList)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_INTRODUCTION', introduction)
        commit('SET_USERNAME', userName)
        commit('SET_FULLNAME', fullName)
        commit('SET_USERINFO', response)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * @description: 用户退出
   * @author: linwen linwen@fjxhx.com
   * @createDate: 2020-10-22 22:01
   */
  logout({ commit }) {
    return new Promise(resolve => {
      // eslint-disable-next-line no-undef
      commit('SET_USERNAME', '')
      commit('SET_FULLNAME', '')
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      commit('SET_USERINFO', {})
      removeToken()
      resolve()
    })
  },

  /**
   * @description: 移除 token
   * @author: linwen linwen@fjxhx.com
   * @createDate: 2020-10-22 22:01
   */
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_USERNAME', '')
      commit('SET_FULLNAME', '')
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      commit('SET_USERINFO', {})
      removeToken()
      resolve()
    })
  },
  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getInfo')
    console.log('roles:', roles)

    // generate accessible routes map based on roles
    // const accessRoutes = await dispatch('permission/generateRoutes')
    // dynamically add accessible routes
    // router.addRoutes(accessRoutes)

  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




//
//
// username: superadmin
// password: 3e1e211bbf306756e8a0e8ccbe134810519ef182081e9982ed78bd8d5b40c9c06c34acd4abd4b2e22f96f18aa198d4df40dac844501bbe94085e00547ffa9d74
// grant_type: password
// scope: server
// client_id: D052FD0EC80D4D215440366441343107
// client_secret: 6edbbdfda8ebf2e17bf7e6f3409fdaeacabe8e49f5dc38610a5548f051d64d8e343f3426e77bba4d16fb40a1b5714a5b7299bd6f20646acbc6e4259d24bee0f2



// WEBPACK FOOTER //
// ./src/store/modules/user.js